import { Saga } from 'redux-saga'
import {
  ActionPattern,
  all,
  call,
  put,
  select,
  takeLatest,
} from 'redux-saga/effects'
import { Quizzes } from 'src/graphql/Services'
import DOMPurify from 'isomorphic-dompurify'

import { actions, selectors } from '..'
import ApiSagas from '../api/sagas'

export default class QuizzResultsSagas {
  static *init(context: any) {
    const {
      query: { page = 1 },
    } = context

    const sanitizedPage = DOMPurify.sanitize(page)

    yield put(actions.quizzResults.setQuizzesPage(parseInt(sanitizedPage, 10)))
    return yield call(QuizzResultsSagas.loadQuizzes)
  }

  static *loadQuizzes() {
    const page: number = yield select(selectors.quizzResults.page)

    const { data: result } = yield call(
      ApiSagas.query,
      Quizzes.queries.quizzes({
        first: page * 9,
        page: 1,
      })
    )

    yield put(
      actions.quizzResults.setHasMorePages(result?.paginatorInfo?.hasMorePages)
    )

    yield put(actions.quizzResults.setQuizzes(result?.data))
    return
  }

  static *loadMoreQuizzes() {
    const page: number = yield select(selectors.quizzResults.page)
    const newPage = page + 1

    const { data: result } = yield call(
      ApiSagas.query,
      Quizzes.queries.quizzes({
        first: 9,
        page: newPage,
      })
    )

    yield put(
      actions.quizzResults.setHasMorePages(result.paginatorInfo.hasMorePages)
    )

    yield put(actions.quizzResults.setQuizzesPage(newPage))
    yield put(actions.quizzResults.appendQuizzes(result?.data))

    if (!result) {
      return { error: 404 }
    }
  }

  static *loop() {
    yield all([
      takeLatest(
        actions.quizzResults.loadMoreQuizzesPage as ActionPattern,
        this.loadMoreQuizzes as Saga
      ),
    ])
  }
}
